import { deterministicUuid } from "./uuid.ts";

export function hash128(value: string): string {
  const NAMESPACE = "9b5c1f24-6d3a-4e88-a0f7-2c41b8e35d90";
  const hash = deterministicUuid({ namespace: NAMESPACE, value });

  return hash.replaceAll("-", "");
}

export function hash16(value: string): string {
  const NAMESPACE = "c30ffe7e-00e8-423d-b9bf-37ddc8dff0a6";

  const LENGTH = 4;

  const hash = deterministicUuid({ namespace: NAMESPACE, value });

  return hash.slice(0, LENGTH);
}

export function hash32(value: string): string {
  const NAMESPACE = "ec59b30f-58ca-44d2-a91d-e6bc4fc09f76";

  const LENGTH = 8;

  const hash = deterministicUuid({ namespace: NAMESPACE, value });

  return hash.slice(0, LENGTH);
}
